<template>
  <div class="full-width">
    <TextField
      v-model="formData.processor_name"
      label="Processor Name"
      placeholder="Processor Name"
      class="full-width mb-2"
      name="Processor Name"
      :error-message="firstErrorMessage(v$.processor_name)"
    />
    <TextField
      v-model="formData.reference_id"
      label="Reference #"
      placeholder="Reference #"
      class="full-width mb-3"
      name="Reference #"
      :error-message="firstErrorMessage(v$.reference_id)"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { firstErrorMessage } from "@/lib/vuelidate_helpers";

import TextField from "@/components/TextField.vue";
import { useVuelidate } from "@vuelidate/core";
import { helpers, requiredIf } from "@vuelidate/validators";

const formData = ref({
  processor_name: "",
  reference_id: ""
});

const v$ = useVuelidate(
  {
    processor_name: {
      required: helpers.withMessage(
        "A processor name or reference # is required",
        requiredIf(() => !formData.value.reference_id)
      ),
      $autoDirty: true
    },
    reference_id: {
      required: helpers.withMessage(
        "A processor name or reference # is required",
        requiredIf(() => !formData.value.processor_name)
      ),
      $autoDirty: true
    }
  },
  formData.value
);

async function validate() {
  const validated = await v$.value.$validate();
  if (!validated) throw new Error("invalid");
}

function getData() {
  return { ...formData.value };
}

defineExpose({ validate, getData });

defineProps({
  form: { type: Object as () => typeof formData, default: null }
});
</script>
